import { assert } from '../../errors';
import {
    ExternalFinancialEntity,
    isExternalFinancialEntity,
} from '../../financialEntities';
import { sortBy } from '../../util/arrays';
import { useFinancialEntitiesContext } from './context';
import { isDisconnectedOrError } from './helpers';

export type Institution = {
    financialEntity: ExternalFinancialEntity;
    sharedCount: number;
    privateCount: number;
    isDisconnectedOrError: boolean;
    name: string;
};

export const useInstitutions = (): Institution[] => {
    const { fes } = useFinancialEntitiesContext();

    const financialEntitiesWithCount: Record<string, Institution> = {};

    if (!fes.unfilteredData) {
        console.error('No fes loaded in InstitutionList component');
        return [];
    }

    const myExternalFEs = fes.unfilteredData.financialEntities.filter(
        (fe) =>
            isExternalFinancialEntity(fe) &&
            fe.isMine &&
            fe.linkStatus !== 'MANUAL' &&
            fe.institution?.name
    ) as ExternalFinancialEntity[];

    for (const fe of myExternalFEs) {
        assert(fe.institution?.name);

        const sharedCount =
            financialEntitiesWithCount[fe.institution.name]?.sharedCount || 0;
        const privateCount =
            financialEntitiesWithCount[fe.institution.name]?.privateCount || 0;

        financialEntitiesWithCount[fe.institution.name] = {
            name: fe.institution.name,
            financialEntity: fe,
            sharedCount: sharedCount + (fe.shareStatus === 'SHARED' ? 1 : 0),
            privateCount: privateCount + (fe.shareStatus === 'PRIVATE' ? 1 : 0),
            isDisconnectedOrError: isDisconnectedOrError(fe),
        };
    }

    return sortBy(
        Object.values(financialEntitiesWithCount),
        ({ financialEntity }) => {
            assert(financialEntity.institution?.name);
            return financialEntity.institution.name;
        },
        'ASC'
    );
};
